import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  reconnectUnsupportedToast: {
    id: "funding-application: reconnect air unsupported connection type toast",
    defaultMessage: "We can't reconnect this platform yet. Please contact support for help.",
  },
});
